import styled from "styled-components";
import SVG from "react-inlinesvg";

export const Container = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 22px;
    justify-content: space-evenly;
    padding: 12px;
    width: 100%;

    button{
        float: right;
        font-size: 18px;
        font-weight: 600;
        margin-top: 8px;
        padding: 8px 12px;
        text-transform: uppercase;
    }
`;

export const ContainerMonths = styled.div` 
    display: flex;
    flex: 26;
    gap: 22px;
    overflow: auto;
    &::-webkit-scrollbar {
        height : 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
    
    @media (orientation: landscape) and (min-width: 1080px){
        justify-content: center;
    }
`;

export const MonthContainer = styled.button`
    align-items: center;
    background: ${(props)=>(props.$selected ? props.$background : 'transparent')};
    border: none;
    border-radius: 5px;
    color: ${(props)=> props.$selected ? '#fff' : '#333'};
    cursor: pointer;
    display: flex;
    flex-direction: column;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    height: 30px;
    justify-content: center;
    line-height: normal;
    outline: none;
    padding: 8px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    transition: 1s;
    &:disabled{
        color: #A3A3A3;
        cursor: auto;
    }
    @media (min-width: 720px) {
        font-size: 18px;
        height: 48px;
        padding: 12px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 14px;
        height: 30px;
        padding: 8px;
    }
`;

export const ActiveIndicator = styled.img`
    bottom: 0;
    height: 24px; 
    position: absolute;
    width: 27px;
`;

export const SelectMonth = styled.select`
    align-items: center;
    align-self : center;
    background: #006560;
    border-radius: 10px;
    border: none;
    color: #FFF;
    cursor: pointer;
    display: flex;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    justify-content: center;
    line-height: normal;
    outline: none;
    padding: 20px 25px;
    text-align: center;
`;

export const StyledOption = styled.option`
    align-items: center;
    color: #FFF;
    font-size: 15px;
    font-weight: 600; 
    font-style: normal;
    justify-content: center;
    line-height: 0;
    text-align: start;
`;

export const TypeSelect = styled.select`
    align-items: center;
    align-self : center;
    background: #FFF;
    border : 2px solid #006560;
    border-radius: 5px;
    color: #006560;
    cursor: pointer;
    display: flex;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    height: 30px;
    justify-content: center;
    line-height: normal;
    max-width: 115px;
    outline: none;
    padding: 0px 8px;
    text-align: center;
    @media (min-width: 720px) {
        font-size: 15px;
        height: 48px;
        padding: 0px 25px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 10px;
        height: 30px;
        padding: 0px 8px;
    }
`;

export const TypeOption = styled.option`
    align-items: center;
    color: #006560;
    font-size: 10px;
    font-weight: 600; 
    font-style: normal;
    justify-content: center;
    line-height: 0;
    text-align: start;
    @media (min-width: 720px) {
        font-size: 15px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 10px;
    }
`;


export const BackIcon = styled(SVG)`   
    height: 20px;
    width: 20px;
`;